import React from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import helperNumber from "../../../helpers/numbers";
import tickets from "./tickets";
import TicketStatus from "./TicketStatus";
import { Link } from "react-router-dom";

export default function AllTickets() {
  const setBadgeForStatus = (statusTitle) => {
    let tagBadge;
    switch (statusTitle) {
      case TicketStatus.stateTicket.TICKET_STATE_PENDING:
        tagBadge = <span className="badge badge-warning">{statusTitle}</span>;
        break;
      case TicketStatus.stateTicket.TICKET_STATE_ANSWERED:
        tagBadge = <span className="badge badge-info">{statusTitle}</span>;
        break;
      case TicketStatus.stateTicket.TICKET_STATE_CLOSED:
        tagBadge = <span className="badge badge-success">{statusTitle}</span>;
        break;
    }

    return tagBadge;
  };

  const generateTickets = () => {
    return (
      <>
        <div className="pb-2">
          <Link className="btn btn-success" to="/ticket/add">
            <span className="pl-2">
              <i className="fa fa-plus"></i>
            </span>
            <span>درخواست پشتیبانی </span>
          </Link>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space ">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تیکت</td>
                <td>عنوان تیکت</td>
                <td>دسته</td>
                <td>وضعیت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {tickets.map((userTicket, index) => {
                return (
                  <tr key={index}>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{helperNumber.toPersianNum(userTicket.id)}</td>
                    <td>{userTicket.title}</td>
                    <td>{userTicket.category}</td>
                    <td>{setBadgeForStatus(userTicket.status)}</td>
                    <td>{helperNumber.toPersianNum(userTicket.createAt)}</td>

                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/ticket/view/${userTicket.id} `}
                            className="btn btn-success"
                          >
                            <i className="fa fa-eye"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar activeItem="all-user-tickets" openItem="tickets" />

      <div className="content-wrapper">
        <TitleBar title="درخواست پشتیبانی" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">{generateTickets()}</div>
          </div>
        </section>
      </div>
    </>
  );
}
